<template>
  <div id="app">
    <nav_top />
    <transition name="el-fade-in-linear" mode="out-in">
      <router-view />
    </transition>
    <footer_ />
  </div>
</template>
<script>
import nav_top from "@/components/nav_top.vue";
import footer_ from "@/components/footer_.vue";
export default {
  components: {
    nav_top,
    footer_,
  },
};
</script>

<style lang="less">
*,
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  min-height: 100vh;
  position: relative;
  background-color: #f5f6f8;
}
.nocontent {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 145px;
  }
  p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999;
    padding: 20px 0;
  }
}
ul,
ol {
  list-style: none;
}
a {
  text-decoration: none;
  color: #000;
}
.container {
  width: 1200px;
  margin: 0 auto;
  // overflow: hidden;
}

.taj {
  text-align: justify;
}
.tac {
  text-align: center;
}
.clearfloat::after {
  content: "";
  height: 0;
  clear: both;
  display: block;
}
.page_wrap {
  padding-bottom: 30px;
  margin-top: 30px;
  text-align: center;
}
.multifile_img {
  img,
  .el-image {
    display: block !important;
    // vertical-align: middle;
  }
}
.flex {
  display: flex;
  align-items: center;
}

// 寄宿自习室
.adsense {
  margin-top: 24px;
}
.adsense_marking {
  width: 100%;
  height: 100%;
  background: transparent;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}
.adsense_img {
  width: 750px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
